import { TranslationKeys } from '~frontend-common/i18n/english/property-characteristics.i8n';

const keys: TranslationKeys = {
  propertyCharacteristics: {
    fieldsHelperText: {
      propertyCharacteristics: {
        bathroomsNumber: 'Nombre de salles de bain',
        constructionYear: 'Année de construction',
        fireHydrantDistance: 'Distance de la borne-fontaine',
        fireStationDistance: 'Distance de la caserne de pompiers',
        propertySize: 'Superficie (en pi²)',
        storeysNumber: "Nombre d'étages",
        unitsNumber: "Nombre d'unités dans le bâtiment",
      },
    },
    inputHelpers: {
      constructionYear: {
        description:
          "Pour connaître l'année de construction, consultez l'évaluation foncière de votre immeuble disponible sur le site internet de votre ville. Si vous êtes locataire, vous pouvez demander à votre propriétaire ou surintendant.",
        title: 'Année de construction',
      },
      fireResistive: {
        description:
          'Le terme "résistant au feu" réfère à la construction de bâtiments qui résistent aux dommages causées par les incendies et empêchent la propagation du feu.',
        note: "<0> REMARQUE </0>: Un bâtiment est considéré comme résistant au feu lorsqu'il comporte 6 unités ou plus et qu'il a été construit entre 1975 et {{0}}.",
        title: 'Résistant au feu',
      },
      numberOfBathrooms: {
        description:
          "Une 1/2 salle de bain est simplement une pièce qui comprend un lavabo et des toilettes mais pas de douche ni de baignoire. Si l'immeuble a plusieurs unités (ex: duplex, triplex, etc), entrez le nombre total de salles de bain toutes unités confondues.",
        title: 'Nombre de salle de bains',
      },
      numberOfStoreys: {
        description: "Entrez le nombre total d'étages (excluant le sous-sol) dans votre immeuble",
        title: "Nombre d'étages",
      },
      numberOfUnits: {
        description:
          "Entrez le nombre total d'unités dans votre immeuble. Si vous n'êtes pas certain, estimez en multipliant le nombre d'unités d'un étage normal par le nombre d'étages du bâtiment. Si vous vivez dans une maison, écrivez 1.",
        title: "Nombre d'unités",
      },
      propertySize: {
        description:
          "Entrez la superficie totale de votre immeuble en pieds carrés <0>en excluant</0> le sous-sol et le garage. Si vous n'êtes pas certain, utilisez la calculatrice ci-dessous pour obtenir la superficie de votre immeuble.",
        fields: {
          length: 'Longueur',
          stories: 'Étages',
          width: 'Largeur',
        },
        footer: {
          apply: 'Oui',
          measure: 'pi²',
          result: 'Superficie immeuble',
          subtitle: "Voulez-vous utiliser {{0}} pi² comme superficie de l'immeuble?",
        },
        measurementSystem: {
          imperial: 'Pieds',
          metric: 'Mètres',
        },
        title: 'Superficie',
      },
    },
    titles: {
      isFireResistive: 'Le bâtiment est-il résistant au feu?',
    },
  },
};

export default keys;
